import { UsersUiPlugin } from '@wholebodyapp/plugin-users/ui';
import { ScreeningPlugin } from '@wholebodyapp/screening-plugin/ui';

export default {
  name: "Whole Body App",
  plugins: [
    ScreeningPlugin,
    UsersUiPlugin, // in this case, it's an object, but it could be a function!
  ]
}
